import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { cooperplaceApi } from 'services/api';

import { useSnackbar } from 'v3/components/Snackbar';
import Text from 'v3/components/Text';

import { AggregationsProvider } from './context';

import { RegisterAggregationOffer as Register } from '../RegisterOffer';
import { AggregationDetails as Details } from '../Details';

function getInitialAggregationState() {
  return {
    person_type: '',
    contact_email: '',
    contact_phone: '',
    province: null,
    province_id: null,
    city: null,
    city_id: null,
    active: null,
    main_unit_vehicle_only: null,
    vehicleType: null,
    vehicle_type_id: null,
    veichleAxi: null,
    vehicle_axi_id: null,
    tracker: null,
    tracker_id: null,
    minimum_age: '',
    quantity: '',
    observation: '',
    company: null,
  };
}

function normalizeAggregation(data) {
  const vehicleType = data?.vehicleType || data?.vehicle_type || null;
  const hasAllVehicleTypes =
    (data?.vehicle_type_id === null || data?.vehicle_type_id === undefined) && !vehicleType?.id;

  return {
    ...data,
    vehicleType: vehicleType || (hasAllVehicleTypes ? { id: 'null', name: 'Todos' } : null),
    vehicle_type_id: hasAllVehicleTypes
      ? 'null'
      : data?.vehicle_type_id || vehicleType?.id || null,
    veichleAxi: data?.veichleAxi || data?.axisType || null,
    vehicle_axi_id:
      data?.vehicle_axi_id ||
      data?.axis_type_id ||
      data?.axisType?.id ||
      data?.veichleAxi?.id ||
      null,
  };
}

export default function AggregationShared() {
  const snackbar = useSnackbar();
  const params = useParams();

  const [aggregation, setAggregation] = useState(getInitialAggregationState);
  const [prevAggregation, setPrevAggregation] = useState(getInitialAggregationState);
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState({});

  function showSnackbar(text, options) {
    snackbar.show(<Text>{text}</Text>, options);
  }

  useEffect(() => {
    async function fetchAggregation() {
      try {
        setIsFetching(true);
        const response = await cooperplaceApi.get(`aggregation-offer/${params.id}`);
        const data = normalizeAggregation(await response.data);
        setAggregation(data);
        setPrevAggregation(data);
      } catch (error) {
        showSnackbar('Ocorreu um erro ao carregar as informações da oferta de agregamento', {
          type: 'error',
        });
      } finally {
        setIsFetching(false);
      }
    }
    if (params.id) {
      fetchAggregation();
      return;
    }

    setAggregation(getInitialAggregationState());
    setPrevAggregation(getInitialAggregationState());
    setErrors({});
    setIsFetching(false);
  }, [params.id]);

  function setData(data) {
    setAggregation((prev) => ({ ...prev, ...data }));
  }

  function updatePrevAggregation() {
    setPrevAggregation(aggregation);
  }

  function handleCancel() {
    setAggregation(prevAggregation);
  }

  return (
    <AggregationsProvider
      value={{
        data: aggregation,
        setData,
        isFetching,
        errors,
        setErrors,
        showSnackbar,
        handleCancel,
        updatePrevAggregation,
        prevAggregation,
      }}
    >
      {params.id ? <Details /> : <Register />}
    </AggregationsProvider>
  );
}
